import { http } from '@/utils/http';
import { StandaloneNewsletterSignup, StandaloneNewsletterSignupProps } from 'base/components/NewsletterSignup';
import { standaloneNewsletterSignupDefaults } from 'base/components/NewsletterSignup/NewsletterSignup.constants';
import deepmerge from 'deepmerge';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { FieldValues, SubmitHandler } from 'react-hook-form';

export interface AllasStandaloneNewsletterSignupProps extends StandaloneNewsletterSignupProps {
  onSuccess?: () => void | Promise<void>;
}

export const AllasStandaloneNewsletterSignup = ({
  inputs,
  options,
  onSuccess,
  ...props
}: AllasStandaloneNewsletterSignupProps) => {
  const fields = standaloneNewsletterSignupDefaults.inputs?.fields;

  const onSubmitValid: SubmitHandler<FieldValues> = async (data) => {
    const response = await http.post('/api/newsletter/signup', { data });

    if (response?.status === 200) {
      await onSuccess?.();
      return response;
    }
    throw response;
  };

  const availableNewsletters = getOcelotConfig('features.newsletterSignup.availableNewsletters');

  const checkboxes = Object.entries(availableNewsletters).map(([value, label]) => ({
    $standalone: { label, name: 'newsletter', value, options: { $label: { size: 'none' } } },
    rules: { required: '* Välj ett eller flera nyhetsbrev' },
  }));

  return (
    <StandaloneNewsletterSignup
      options={deepmerge<StandaloneNewsletterSignupProps['options']>(options, {
        $button: {
          size: 'large',
        },
        onSubmitValid,
      })}
      inputs={{ checkboxes, fields }}
      {...props}
    />
  );
};
